import React, { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter } from "react-router-dom";
import store from "./store/store";
import { SupportAuthProvider } from "./context/SupportAuthContext";
import {
  initRealtimeListeners,
  removeRealtimeListeners,
} from "./realtime/socketListener";

function App() {
  useEffect(() => {
    initRealtimeListeners(store.dispatch);
    return () => {
      removeRealtimeListeners();
    };
  }, []);

  return (
    <BrowserRouter>
      <SupportAuthProvider>
        <AppRoutes />
      </SupportAuthProvider>
    </BrowserRouter>
  );
}

export default App;